<template>
    <div>
        <el-carousel :height="bannerHeight + 'px'" :interval="2000" :autoplay="true">
            <el-carousel-item v-for="(item, index) in sliders" :key="index">
                <img :src="item.img" style="width:100%;" class="slider_img" ref="bannerHeight" width="100%" @load="imgLoad">
            </el-carousel-item>
        </el-carousel>
        <div :style="{backgroundImage: 'url('+bgImage+')'}" style="width: 100%;padding-top:80px;background-position: center top;background-repeat: no-repeat;background-size: cover;">
            <!-- <div class="parallel"></div> -->
            <div style="width:86%;margin-left:10%;position:relative;">
                <img style="width:55%;" src="../assets/wenhua10.jpg"/>
                <div class="parallel" style="position:absolute;top:-10px;left:49%;padding:20px;display:flex;justify-content: center;align-items: center;">
                    
                </div>
                <div style="position:absolute;top:80px;left:58%;">
                    <div style="font-size:34px;font-weight:600;color:#3fa8c7;">开放的文化沟通氛围</div>
                    <div style="font-size:34px;font-weight:600;color:#3fa8c7;margin-top:10px;">
                        完善的人才培养机制
                    </div>
                    <div style="font-size:22px;margin-top:20px;">高度扁平化的管理架构，助力你每一个优秀想法和创意的展示</div>
                    <div style="font-size:22px;margin-top:10px;">多元透明的职业发展通道，护航每一匹“千里马”实现价值。</div>
                </div>
                <div style="position:absolute;top:150px;right:30px;text-align:center;">
                    <img style="width:32px;" src="../assets/juxing3.png"/>
                    <img style="width:32px;" src="../assets/juxing1.png"/>
                    <img style="width:32px;margin-left:-20px;" src="../assets/juxing2.png"/>
                    <img style="width:32px;" src="../assets/juxing3.png"/>
                </div>
            </div>
            <div style="width:90%;margin:0 auto;display:flex;margin-top: 110px;">
                <div style="width:45%;text-align:right;padding-top:30px;">
                    <div>
                        <img style="width:32px;" src="../assets/juxing3.png"/>
                        <img style="width:32px;" src="../assets/juxing1.png"/>
                        <img style="width:32px;margin-left:-20px;" src="../assets/juxing2.png"/>
                        <img style="width:32px;" src="../assets/juxing3.png"/>
                    </div>
                    <div style="font-size:22px;margin-top:5px;">在汇升</div>
                    <div style="font-size:22px;margin-top:10px;">你会发现全新的工作机遇与挑战、专业可信的团队</div>
                    <div style="font-size:22px;margin-top:10px;">以及完善成熟的培训发展体系</div>
                    <div style="font-size:22px;margin-top:10px;">每一位领导和同事</div>
                    <div style="font-size:22px;margin-top:10px;">都是亦师亦友的靠谱同路人。</div>
                </div>
                <img style="width:50%;margin-left:5%;" src="../assets/wenhua13.jpg"/>
            </div>
            <div style="width:90%;">
                <img style="width:45%;margin-top:-60px;transform: translateX(30%);" src="../assets/wenhua3.jpg"/>
            </div>
            <div style="width:90%;text-align:right;">
                <img style="width:52%;margin-top:-80px;transform: translateX(0%);" src="../assets/wenhua11.jpg"/>
            </div>
            <div style="width:90%;margin:0 auto;margin-top:52px;display:flex;">
                <img style="width:50%;" src="../assets/wenhua9.jpg"/>
                <div style="width:45%;margin-left:3%;padding:20px;display:flex;align-items: center;">
                    <div>
                        <div style="font-size:34px;font-weight:600;color:#3fa8c7;">快乐工作</div>
                        <div style="font-size:34px;font-weight:600;color:#3fa8c7;margin-top:10px;">健康生活
                            <div style="display:inline-block;margin-left:20px;vertical-align: sub;">
                                <img style="width:32px;" src="../assets/juxing3.png"/>
                                <img style="width:32px;" src="../assets/juxing1.png"/>
                                <img style="margin-left:-20px;width:32px;" src="../assets/juxing2.png"/>
                                <img style="width:32px;" src="../assets/juxing3.png"/>
                            </div>
                        </div>
                        <div style="font-size:22px;margin-top:20px;">丰富多彩的文化活动</div>
                        <div style="font-size:22px;margin-top:10px;">暖心实用的福利奖品</div>
                        <div style="font-size:22px;margin-top:10px;">关注你飞得高的同时</div>
                        <div style="font-size:22px;margin-top:10px;">也小心呵护你的健康快乐</div>
                    </div>
                </div>
            </div>
            <div style="width:90%;margin:0 auto;margin-top:80px;position:relative;">
                <img style="width:45%;transform: translateX(15%);" src="../assets/wenhua7.jpg"/>
                <img style="width:38%;position:absolute;right:0%;top:-80px;;" src="../assets/wenhua12.jpg"/>
            </div>
            <div style="width:90%;text-align:right;">
                <img style="width:50%;margin-top:-60px;transform: translateX(0%);" src="../assets/wenhua8.jpg"/>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Index',
        data() {
            return {
                bgImage: require('../assets/huishengwenhua_bg.png'),
                sliders: [],
                bannerHeight: '',
                titles: [{
                    name: '首页',
                    value: '/index'
                }, {
                    name: '走进汇升',
                    value: '/enterHS'
                }, {
                    name: '汇升文化',
                    value: '/hsCulture'
                }, {
                    name: '汇升投教',
                    value: '/hsInvestEducation'
                }, {
                    name: '汇升招聘',
                    value: '/hsEngage'
                }],
                carousel_height: '550px',
            }
        },
        methods: {
            changeTitle(item) {
                this.$router.push({
                    path: item.value,
                    // query: {
                    //     id: this.roleId,
                    //     ids: this.checkList
                    // }
                })
            },
            imgLoad() {
                this.$nextTick(() => {
                    this.bannerHeight = this.$refs.bannerHeight[0].height
                })
            }
        },
        mounted() {
            this.imgLoad()
            this.sliders = [
                // {
                //     img: require("../assets/banner2-1.jpg")
                // },
                {
                    img: require("../assets/banner2-2.jpg")
                },
                {
                    img: require('../assets/banner2-3.jpg')
                },
                // {
                //     img: require('../assets/banner2-4.jpg')
                // }
            ]

            this.timer = setInterval(() => {
                let osTop = document.documentElement.scrollTop || document.body.scrollTop;
                let ispeed = Math.floor(-osTop / 5)
                document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
                if (osTop === 0) {
                    clearInterval(this.timer)
                }
            }, 10)
        },
        computed: {

        },
    }
</script>
<style scoped>
.parallel {
    margin-top: 50px;
    margin-left: 50px;
    width: 45%;
    height: 250px;
    background: #ffffff;
    transform: skew(-20deg, 0);
}
</style>


// WEBPACK FOOTER //
// src/components/hsCulture.vue